import { render, staticRenderFns } from "./InputMain.vue?vue&type=template&id=67713782&"
import script from "./InputMain.vue?vue&type=script&lang=js&"
export * from "./InputMain.vue?vue&type=script&lang=js&"
import style0 from "./InputMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports